import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Dialog,
  DialogContent,
} from "@mui/material";
import Tetris from "../Components/PlayGround/Tetris";
import Gallery from "../Components/PlayGround/Gallery";
import ProteinCalculator from "../Components/PlayGround/ProteinCalculator";
import MemoryGame from "../Components/PlayGround/MemoryGame";
import Stacks3D from "../Components/PlayGround/Stacks3D";
import MusicMixer from "../Components/PlayGround/MusicMixer";

import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import CollectionsIcon from "@mui/icons-material/Collections";
import CalculateIcon from "@mui/icons-material/Calculate";

const images = [
  {
    img: "./Assets/Gallery/nature.jpg",
    title: "Nature",
  },
  { img: "./Assets/Gallery/city.jpg", title: "City" },
  {
    img: "./Assets/Gallery/mountain.jpg",
    title: "Mountain",
  },
  { img: "./Assets/Gallery/forest.jpg", title: "Forest" },

  { img: "./Assets/Gallery/water.jpg", title: "Water" },

  { img: "./Assets/Gallery/lake.jpg", title: "Lake" },
];

export default function Things() {
  const [openTetris, setOpenTetris] = useState(false);
  const [openGallery, setOpenGallery] = useState(false);
  const [openProteinCalculator, setOpenProteinCalculator] = useState(false);
  const [openMemory, setOpenMemory] = useState(false);
  const [openStack3D, setOpenStack3D] = useState(false);
  const [openMusicMixer, setOpenMusicMixer] = useState(false);

  const displayCard = (title, description, open, setShow, thing, icon) => {
    return (
      <Grid item xs={12} md={4}>
        <Card
          sx={{
            backgroundColor: "#1b3a57",
            color: "#fff",
            minHeight: 280,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            transition: "transform 0.3s, box-shadow 0.3s",
            "&:hover": {
              transform: "translateY(-8px)",
              boxShadow: "0 8px 20px rgba(0,0,0,0.4)",
              mt: -2,
            },
          }}
        >
          <CardContent
            sx={{
              flex: 1,
              width: 380,
              overflow: "hidden",
              p: 3,
              display: "flex",
              flexDirection: "column",
              alighnItems: "center",
              fontSize: 8,
              justifyContent: "flex-start",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 1,
              }}
            >
              {icon}
              {/* <VideogameAssetIcon
                sx={{
                  fontSize: 60,
                  color: "#2d8a82ff",
                  mb: 0,
                }}
              /> */}
            </Box>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ color: "#e0e0e0", letterSpacing: 2 }}
            >
              {title}
            </Typography>
            <Typography sx={{ color: "#e0e0e0", letterSpacing: 1, mt: 1 }}>
              {description}
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#2d8a82ff",
                color: "#fff",
                mt: 2,
                "&:hover": {
                  backgroundColor: "#2d9990ff",
                },
              }}
              // onClick={handleClick}
              onClick={() => setShow(true)}
            >
              Play
            </Button>
          </CardContent>
        </Card>
        <Dialog
          open={open}
          onClose={() => setShow(false)}
          maxWidth="md"
          fullWidth
        >
          {/* <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth> */}
          <DialogContent
            sx={{
              backgroundColor: "#102e43",
              p: 4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "80vh",
            }}
          >
            {thing}
          </DialogContent>
        </Dialog>
      </Grid>
    );
  };

  const GameContainer = () => {
    return (
      <div
        style={{
          width: "800px",
          height: "600px",
          margin: "20px auto",
          border: "2px solid #333",
          position: "relative",
        }}
      >
        <Stacks3D />
      </div>
    );
  };

  return (
    <Box
      sx={{
        backgroundColor: "#102e43",
        minHeight: "80vh",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        color: "#102e43",
        px: 2,
        position: "relative",
      }}
    >
      <Button
        variant="contained"
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          backgroundColor: "#1b3a57",
          color: "#f8fafcff",
          fontWeight: 400,
          letterSpacing: 2,
          boxShadow: 2,
          "&:hover": {
            backgroundColor: "#1f4263ff",
          },
        }}
        href="/"
      >
        Home
      </Button>

      <Grid
        container
        spacing={4}
        justifyContent="center"
        alignItems="stretch"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          py: 12,
        }}
      >
        {displayCard(
          "Tetris Game",
          "A modern, AI-designed Tetris game component featuring dynamic visuals, smooth block animations, and responsive controls. Built for seamless integration into web interfaces, it showcases generative design elements that blend creativity and functionality.",
          openTetris,
          setOpenTetris,
          <Tetris />,
          <VideogameAssetIcon
            sx={{
              fontSize: 60,
              color: "#2d8a82ff",
              mb: 0,
            }}
          />
        )}

        {displayCard(
          "Gallery Wall",
          "A curated fusion of art and intelligence — this AI-generated gallery wall transforms digital imagination into visual storytelling. Each piece flows together in perfect harmony, blending texture, tone, and emotion into a modern showcase of creativity.",
          openGallery,
          setOpenGallery,
          <Gallery images={images} />,
          <CollectionsIcon
            sx={{
              fontSize: 60,
              color: "#2d8a82ff",
              mb: 0,
            }}
          />
        )}

        {displayCard(
          "Protein Calculator",
          "An interactive AI generated component that calculates your personalized daily protein requirements. It dynamically adjusts recommendations, and offers quick food equivalents — helping users plan their protein intake with ease.",
          openProteinCalculator,
          setOpenProteinCalculator,
          <ProteinCalculator />,
          <VideogameAssetIcon
            sx={{
              fontSize: 60,
              color: "#2d8a82ff",
              mb: 0,
            }}
          />,
          <VideogameAssetIcon
            sx={{
              fontSize: 60,
              color: "#2d8a82ff",
              mb: 0,
            }}
          />
        )}

        {displayCard(
          "Memory Game",
          "A dynamic AI designed memory game component that challenges users to test and improve their short-term memory through interactive card-matching gameplay. Features animations for an engaging and fun experience.",
          openMemory,
          setOpenMemory,
          <MemoryGame />,
          <VideogameAssetIcon
            sx={{
              fontSize: 60,
              color: "#2d8a82ff",
              mb: 0,
            }}
          />
        )}

        {displayCard(
          "Stack3d Game",
          "A 3D stacking game where players must balance blocks to reach new heights. Featuring dynamic physics and engaging visuals, this game challenges coordination and timing skills.",
          openStack3D,
          setOpenStack3D,
          <GameContainer />,
          <VideogameAssetIcon
            sx={{
              fontSize: 60,
              color: "#2d8a82ff",
              mb: 0,
            }}
          />
        )}

        {displayCard(
          "Music Mixer",
          "An interactive music mixer that allows users to blend and layer different sound samples to create unique tracks. Featuring a user-friendly interface with dynamic controls for volume, tempo, and effects.",
          openMusicMixer,
          setOpenMusicMixer,
          <MusicMixer />,
          <CalculateIcon
            sx={{
              fontSize: 60,
              color: "#2d8a82ff",
              mb: 0,
            }}
          />
        )}
      </Grid>
    </Box>
  );
}
